
<form *ngIf="questions.length > 2">
  <div>
    <ng-template
      [ngTemplateOutlet]="eduForm"
      [ngTemplateOutletContext]="{
        form: membersForms[0],
        districts: districts,
        questions: questions,
        index: -1,
        canDelete: false,
        canEditInstitution: !localStorageUtil.getIsInstitutionURL('edu-family')
      }"
    ></ng-template>
  </div>

  <div *ngIf="membersForms.length > 1">
    <div
      *ngFor="let form of membersForms | slice: 1; let index = index"
      class="household-list-form"
    >
      <ng-template
        [ngTemplateOutlet]="eduForm"
        [ngTemplateOutletContext]="{
          form: form,
          districts: districts,
          questions: questions,
          index: index,
          canDelete: true,
          canEditInstitution: true
        }"
      ></ng-template>
    </div>
  </div>

  <div *ngIf="showPreferredDistrictOpt()" class="row preferred-dist">
    <div class="col-sm-12">
      <mat-label
        >{{ "Which is your preferred district?" | translate }} *</mat-label
      >
      <mat-radio-group
        class="district-radio-group"
        [formControl]="preferredDistricControl"
        required
      >
        <mat-radio-button
          class="district-radio-button"
          *ngFor="let dist of selectedDistricts | filterValidInstMemberOptions"
          [value]="dist.id"
          >{{ dist.description }}</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>

  <div class="save-btn">
    <button mat-flat-button (click)="addHouseholdMember()" color="primary">
      {{ "Add Another Student" | translate }}
    </button>
    <button id="save-survey-btn" mat-flat-button color="primary" (click)="showConfimationModal()">
      {{ "Save" | translate }}
    </button>
  </div>
</form>

<ng-template
  #eduForm
  let-form="form"
  let-districts="districts"
  let-questions="questions"
  let-index="index"
  let-canDelete="canDelete"
  let-canEditInstitution="canEditInstitution"
>
  <mat-accordion class="col-sm-9">
    <mat-expansion-panel [expanded]="true" class="bg-secondary">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h6 class="color-primary">
            {{ "Student Information" | translate }} #{{ index + 2 }}
          </h6>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row">
        <div class="col-sm-12">
          <mat-label class="question-label">{{ questions[0].description }} *</mat-label>
          <mat-form-field class="form-field select-answer" appearance="standard">
            <mat-select
              [formControl]="form.controls['districtControl']"
              required
            >
              <mat-option value="">{{
                "Select an option" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let district of districts"
                [value]="district.id"
                >{{ district.description }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <mat-label class="question-label">{{ questions[1].description }} *</mat-label>
          <mat-form-field class="form-field select-answer" appearance="standard">
            <mat-select [formControl]="form.controls['schoolControl']" required>
              <mat-option value="">{{
                "Select an option" | translate
              }}</mat-option>
              <mat-option
                *ngFor="
                  let school of getListOfSchools(
                    form.controls['districtControl'].value
                  )
                "
                [value]="school.id"
                >{{ school.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-label class="question-label">{{ questions[2].description }} *</mat-label>
          <mat-form-field class="form-field select-answer" appearance="standard">
            <mat-select [formControl]="form.controls['gradeControl']" required>
              <mat-option value="">{{
                "Select an option" | translate
              }}</mat-option>
              <mat-option
                *ngFor="
                  let grade of getListOfGrades(
                    form.controls['districtControl'].value,
                    form.controls['schoolControl'].value
                  )
                "
                [value]="grade.id"
                >{{ grade.description }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="institutionService.allInstutions$.value | showAfterHourCare : form.controls['districtControl'].value" class="row">
        <div class="col-sm-12">
          <mat-label class="question-label">{{ questions[8].description }} *</mat-label>
          <mat-form-field class="form-field select-answer" appearance="standard">
            <mat-select [formControl]="form.controls['afterHourCareDistrictControl']" required>
              <mat-option value="">{{
                "Select an option" | translate
                }}</mat-option>
                <mat-option value="0">{{
                  "None/Not Listed" | translate
                  }}</mat-option>
              <mat-option *ngFor="let afterHourCareDistrict of institutionService.allInstutions$.value | filterInstitutionsByType: afterHourCareType" [value]="afterHourCareDistrict.id">{{ afterHourCareDistrict.description }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="form?.controls['needNameControl']?.value" class="row">
        <div class="col-sm-12">
          <mat-label class="question-label">{{ questions[6].description }} </mat-label>
          <mat-form-field class="form-field" appearance="legacy">
            <input matInput [required]="false"
              [formControl]="form.controls['firstNameControl']" />
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="form.controls['needNameControl']?.value" class="row">
        <div class="col-sm-12">
          <mat-label class="question-label">{{ questions[7].description }} </mat-label>
          <mat-form-field class="form-field" appearance="legacy">
            <input matInput [required]="false"
              [formControl]="form.controls['lastNameControl']" />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <mat-label>{{ questions[3].description }}</mat-label>
          <mat-form-field class="form-field select-answer" appearance="standard">
            <mat-select [formControl]="form.controls['genderControl']">
              <mat-option value="">{{
                "Select an option" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let gender of questions[3].questionOptions"
                [value]="gender.id"
                >{{ gender.description }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <mat-label>{{ questions[4].description }}</mat-label>
          <mat-form-field class="form-field select-answer" appearance="standard">
            <mat-select [formControl]="form.controls['raceControl']">
              <mat-option value="">{{
                "Select an option" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let race of questions[4].questionOptions"
                [value]="race.id"
                >{{ race.description }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <mat-label>{{ questions[5].description }}</mat-label>
          <mat-form-field class="form-field select-answer" appearance="standard">
            <mat-select [formControl]="form.controls['ethnicityControl']">
              <mat-option value="">{{
                "Select an option" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let ethnicity of questions[5].questionOptions"
                [value]="ethnicity.id"
                >{{ ethnicity.description }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="canDelete">
        <button mat-flat-button color="primary" (click)="deleteForm(index + 1)">
          {{ "Delete" | translate }}
        </button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
